import { inject } from '@angular/core';
import { NavigationService } from '@features/navigation/services/navigation.service';
import { IdentityStore } from '@features/identity/store/identity.store';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { NAVIGATION_KEYS } from '@features/navigation/navigation.query-keys';
import { lastValueFrom } from 'rxjs';
import { getApiData } from '@shared/utils/api.utils';
import type { ApiResponse } from '@shared/models/api.model';
import type { MenuModulo } from '@features/navigation/models/navigation.model';

export function injectMenuQuery() {
    const navigationService = inject(NavigationService);
    const identity = inject(IdentityStore);

    return injectQuery<ApiResponse<MenuModulo[]>, Error, MenuModulo[]>(() => ({
        queryKey: NAVIGATION_KEYS.menu(),
        queryFn: () => lastValueFrom(navigationService.getMenu()),
        enabled: identity.isAuthenticated(),
        staleTime: Infinity,
        gcTime: Infinity,
        select: getApiData,
    }));
}
